/**
 * @generated SignedSource<<1bc9ede57c387aa8421a2b5c28cbefae>>
 * @relayHash 3d73e91496f9e6d2469f9c2826067174
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f40a4d22efb4c3f6ed63fc6ab98e93c3090b0cdc55a94dde71928e166822ef3b

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EventTicketOrderStatus = "CANCELED" | "PENDING" | "SUCCEEDED" | "%future added value";
export type CreateTicketOrderInput = {
  buyerBusinessName?: string | null | undefined;
  buyerTaxId?: string | null | undefined;
  buyerTaxIdType?: string | null | undefined;
  discountCode?: string | null | undefined;
  eventId: string;
  items: ReadonlyArray<TicketOrderItemInput>;
};
export type TicketOrderItemInput = {
  attendeeEmail?: string | null | undefined;
  attendeeFirstName?: string | null | undefined;
  attendeeLastName?: string | null | undefined;
  forMe?: boolean | null | undefined;
  ticketingTierId: string;
};
export type EventAttendContentCreateOrderMutation$variables = {
  input: CreateTicketOrderInput;
};
export type EventAttendContentCreateOrderMutation$data = {
  readonly createEventTicketOrder: {
    readonly __typename: "CreateEventTicketOrderNoPaymentNeededPayload";
    readonly eventTicketOrder: {
      readonly id: string;
      readonly status: EventTicketOrderStatus;
    } | null | undefined;
  } | {
    readonly __typename: "CreateEventTicketOrderPaymentNeededPayload";
    readonly eventTicketOrder: {
      readonly id: string;
    } | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type EventAttendContentCreateOrderMutation = {
  response: EventAttendContentCreateOrderMutation$data;
  variables: EventAttendContentCreateOrderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "createEventTicketOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EventTicketOrder",
            "kind": "LinkedField",
            "name": "eventTicketOrder",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "CreateEventTicketOrderNoPaymentNeededPayload",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EventTicketOrder",
            "kind": "LinkedField",
            "name": "eventTicketOrder",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "CreateEventTicketOrderPaymentNeededPayload",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventAttendContentCreateOrderMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventAttendContentCreateOrderMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "f40a4d22efb4c3f6ed63fc6ab98e93c3090b0cdc55a94dde71928e166822ef3b",
    "metadata": {},
    "name": "EventAttendContentCreateOrderMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7d0453a777b5c0f52dd1a126fe13f92d";

export default node;
